import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";

import ChangeEmailForm from "../../components/account/ChangeEmailForm.jsx";
import withBasicForm from "../../components/forms/withBasicForm.js";

const ChangeEmailBasicForm = withBasicForm(ChangeEmailForm);

class EmailTab extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    violationErrors: PropTypes.object
  };

  // -- RENDER -- //

  render() {
    return <ChangeEmailBasicForm {...this.props} />;
  }
}

export default EmailTab;
